export default __webpack_public_path__ + "static/reward-4-915720c1a5cc3fd27451764803a6c06d.png";